import React, { memo, useCallback, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { CopyNotify, Requisites, RequisitesProps } from '@bcraft-frontend-lib/payments'
import block from 'bem-cn'

import { selectLocaleDict } from 'features/locale/selectors'

import './RequisitesWrapper.scss'

const b = block('requisites-wrapper')

type RequisitesWrapperParams = {
  requisites: RequisitesProps['requisites']
  className?: RequisitesProps['className']
  locale?: RequisitesProps['locale']
}

const RequisitesWrapper = memo((props: RequisitesWrapperParams) => {
  const { common } = useSelector(selectLocaleDict, shallowEqual)

  const [isCopied, setIsCopied] = useState(false)

  const copyText = useCallback(() => {
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 1000)
  }, [])

  if (!props.requisites?.length) return null
  return (
    <Requisites {...props} locale={{}}>
      {({ name, value, qrCodeImage, onCopy }) => (
        <>
          {qrCodeImage && <div className={b('qr-code')}>{qrCodeImage}</div>}
          <div className={b()}>
            <div className={b('name')}>{name}</div>
            <div className={b('value-wrapper')}>
              <span className={b('value')}>{value}</span>
              <span className={b('icon-wrapper')} onClick={() => onCopy(copyText)}>
                {/* <Icon type="copy" className={b('icon')} /> */}
                {common.copy}
                <CopyNotify isCopied={isCopied} />
              </span>
            </div>
          </div>
        </>
      )}
    </Requisites>
  )
})

export { RequisitesWrapper }
